<template>
     <v-dialog  style="z-index: 1;"
    v-model="dialog"
    max-width="360"
    persistent
    content-class="rounded-xl" 
    transition="dialog-bottom-transition"
  >
     <v-card class="rounded-xl overflow-hidden share-card">
      <!-- Gradient header with animated elements -->
      <v-card-title class="share-header py-5 px-6 d-flex align-center">
        <div class="pulse-circle mr-3">
          <v-icon size="20" color="white">mdi-share-circle</v-icon>
        </div>
        <span class="text-h5 font-weight-bold white--text">Share With Friends</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          small
          @click="onClose"
          class="white--text hover-effect"
          elevation="0"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Content with improved layout -->
      <v-card-text class="py-6 px-6">
        <p class="text-center text-subtitle-1 mb-5">
          Share this opportunity with your network and make a bigger impact together!
        </p>
        
        <div class="share-buttons-container">
          <!-- Facebook -->
          <v-btn
            elevation="2"
            rounded
            block
            class="share-btn facebook-btn mb-4 py-3"
            @click="shareOnFacebook"
          >
            <div class="social-icon-container facebook-icon-container mr-3">
              <v-icon size="20">mdi-facebook</v-icon>
            </div>
            <span class="font-weight-medium">Share on Facebook</span>
            <v-spacer></v-spacer>
            <v-icon small class="arrow-icon">mdi-arrow-right</v-icon>
          </v-btn>

          <!-- Twitter -->
          <v-btn
            elevation="2"
            rounded
            block
            class="share-btn twitter-btn mb-4 py-3"
            @click="shareOnTwitter"
          >
            <div class="social-icon-container twitter-icon-container mr-3">
              <v-icon size="20">mdi-twitter</v-icon>
            </div>
            <span class="font-weight-medium">Share on Twitter</span>
            <v-spacer></v-spacer>
            <v-icon small class="arrow-icon">mdi-arrow-right</v-icon>
          </v-btn>

          <!-- LinkedIn -->
          <v-btn
            elevation="2"
            rounded
            block
            class="share-btn linkedin-btn mb-4 py-3"
            @click="shareOnLinkedIn"
          >
            <div class="social-icon-container linkedin-icon-container mr-3">
              <v-icon size="20">mdi-linkedin</v-icon>
            </div>
            <span class="font-weight-medium">Share on LinkedIn</span>
            <v-spacer></v-spacer>
            <v-icon small class="arrow-icon">mdi-arrow-right</v-icon>
          </v-btn>

          <!-- Copy Link Button -->
          <v-btn
            elevation="2"
            rounded
            block
            class="share-btn copy-btn py-3"
            @click="copyLinkToClipboard"
          >
            <div class="social-icon-container copy-icon-container mr-3">
              <v-icon size="18">mdi-content-copy</v-icon>
            </div>
            <span class="font-weight-medium">Copy Link</span>
            <v-spacer></v-spacer>
            <v-icon small class="arrow-icon">mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </v-card-text>

      <!-- Footer with message -->
      <v-card-actions class="share-footer pa-4">
        <p class="text-center text-body-2 mx-auto">
          Thank you for supporting!
        </p>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="showSnackbar" color="success" :timeout="3000" bottom>
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="showSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    eventUrlData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    onClose: {
      type: Function
    }
  },

  data() {
    return {
      url: "",
      maintitle: "",
      imageUrl:
        "https://akindrcommunity.s3.us-east-2.amazonaws.com/events/6746d979a28c812c91c9a9b2/3836.jpg",
        showSnackbar: false,
      snackbarMessage: "",
    };
  },

  computed: {
    computedUrl() {
      console.log(this.eventUrlData, "eventUrlData");
      console.log(
        `${process.env.VUE_APP_API_URL_UNAUTH}/allHtml/eventHtml/get-event?_id=${this.eventUrlData._id}`,
        "computedUrl"
      );
      return `${process.env.VUE_APP_API_URL_UNAUTH}/allHtml/eventHtml/get-event?_id=${this.eventUrlData._id}`;
    },
    computedTitle() {
      console.log(this.eventUrlData, "eventUrlData");
      console.log(
        `${process.env.VUE_APP_API_URL_UNAUTH}/allHtml/eventHtml/get-event?_id=${this.eventUrlData._id}`,
        "computedUrl"
      );
      return this.eventUrlData.poster.name;
    },
    computedHashtags() {
      return "akinder,volunteer";
    },
    metaTags() {
      return {
        title: this.eventUrlData.title || "Default Event Title",
        meta: [
          {
            property: "og:title",
            content: this.eventUrlData.title || "Default Event Title"
          },
          {
            property: "og:description",
            content: this.eventUrlData.text || "Default Description"
          },
          {
            property: "og:image",
            content:
              this.eventUrlData.posterImage || "https://default-image.jpg"
          },
          {
            property: "og:url",
            content:
              this.url || "http://akindervolunteer.com/backend/default-url"
          },
          { property: "og:type", content: "website" }
        ]
      };
    }
  },

  methods: {
    ...mapActions("event", {}), // Import actions from vuex if needed

      copyLinkToClipboard() {
    const linkToCopy = this.computedUrl; // Use the computed URL
    navigator.clipboard
      .writeText(linkToCopy)
      .then(() => {
        this.snackbarMessage = "Link copied to clipboard!";
        this.showSnackbar = true;
      })
      .catch((err) => {
        console.error("Failed to copy link: ", err);
        this.snackbarMessage = "Failed to copy link. Please try again.";
        this.showSnackbar = true;
      });
  },

    // Open the URL on Facebook
    // fb() {
    //   console.log(JSON.stringify(this.eventUrlData), 'eventUrlData');
    //   // let uri = `${process.env.VUE_APP_WEB_URL}/backend/allHtml/eventHtml/get-event?_id=${this.eventUrlData._id}`;
    //   let uri = `${process.env.VUE_APP_WEB_URL}/event-details?_id=${this.eventUrlData._id}`;
    //   this.url = uri;
    //   try {
    //     let popup = window.open(this.url, '_blank', 'noopener,noreferrer');
    //     if (!popup) {
    //       // Fallback method if popup is blocked
    //       window.location.href = this.url;
    //     }
    //   } catch (e) {
    //     console.error('Popup blocked or other error:', e);
    //     // Fallback method if popup is blocked
    //     window.location.href = this.url;
    //   }
    //   console.log(this.url, 'uri');
    // },

    shareOnFacebook() {
      let eventUrl = `${process.env.VUE_APP_API_URL_UNAUTH}/allHtml/eventHtml/get-event?_id=${this.eventUrlData._id}&posterId=${this.eventUrlData.poster._id}&userType=${this.eventUrlData.poster.type}&postType=Facebook`;
      console.log(eventUrl, "eventUrl");
      let facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        eventUrl
      )}`;
      try {
        let popup = window.open(
          facebookShareUrl,
          "_blank",
          "noopener,noreferrer"
        );
        if (!popup) {
          // Fallback method if popup is blocked
          window.open(facebookShareUrl, "_blank");
        }
      } catch (e) {
        // Fallback method if popup is blocked
        window.open(facebookShareUrl, "_blank");
      }
    },
    shareOnTwitter() {
      const eventUrl =
        this.computedUrl +
        `&posterId=${this.eventUrlData.poster._id}&userType=${this.eventUrlData.poster.type}&postType=Twitter`;
      const text = this.computedTitle;
      const hashtags = this.computedHashtags;
      console.log(eventUrl, "eventUrltwitter");
      const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        eventUrl
      )}&text=${encodeURIComponent(text)}&hashtags=${encodeURIComponent(
        hashtags
      )}`;
      this.openShareWindow(twitterShareUrl);
    },
    shareOnLinkedIn() {
        const eventUrl =`${process.env.VUE_APP_API_URL_UNAUTH}/allHtml/eventHtml/get-event?_id=${this.eventUrlData._id}&posterId=${this.eventUrlData.poster._id}&userType=${this.eventUrlData.poster.type}&postType=LinkedIn`;
        console.log(eventUrl, "eventUrllinkedIn");
        const linkedInShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          eventUrl
        )}`;
        this.openShareWindow(linkedInShareUrl);
      },
    shareOnInstagram() {
      const instagramDeepLink = `instagram://story?background_image=${encodeURIComponent(
        this.imageUrl
      )}`;

      // Open Instagram
      window.location.href = instagramDeepLink;
    },
    openShareWindow(url) {
      try {
        const popup = window.open(url, "_blank", "noopener,noreferrer");
        if (!popup) {
          // Fallback method if popup is blocked
          window.open(url, "_blank");
        }
      } catch (e) {
        // Fallback method if popup is blocked
        window.open(url, "_blank");
      }
    }
  },
  // Using vue-meta to set meta tags dynamically
  metaInfo() {
    return this.metaTags;
  }
};
</script>

<style scoped>
.selected {
  background: #eef3f8;
}

.instagram-color {
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  margin-right: 11px;
}
.twitter-icon {
  margin-right: 11px;
  width: 20px;
  height: auto;
  margin-left: 4px;
}


.success-header {
  background: linear-gradient(135deg, #084468 0%, #1e658d 100%);
}

.share-dialog {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.share-card {
  border: none;
  overflow: hidden;
}

.share-header {
  background: linear-gradient(135deg, #084468 0%, #1e658d 100%);
  position: relative;
  overflow: hidden;
}

.share-header::before {
  content: '';
  position: absolute;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  top: -100px;
  right: -50px;
}

.pulse-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  position: relative;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.pulse-circle::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  animation: pulse 2s infinite;
}

.share-buttons-container {
  max-width: 400px;
  margin: 0 auto;
}

.share-btn {
  text-transform: none;
  letter-spacing: normal;
  font-size: 16px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.share-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.share-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(120deg, rgba(255,255,255,0) 30%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0) 70%);
  transform: translateX(-100%);
  transition: transform 0.6s;
}

.share-btn:hover::before {
  transform: translateX(100%);
}

.facebook-btn {
  background-color: #1877F2 !important;
  color: white !important;
}

.twitter-btn {
  background-color: #1DA1F2 !important;
  color: white !important;
}

.linkedin-btn {
  background-color: #0A66C2 !important;
  color: white !important;
}

.copy-btn {
  background-color: #616161 !important;
  color: white !important;
}

.social-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
}

.facebook-icon-container {
  background-color: rgba(255, 255, 255, 0.25);
}

.twitter-icon-container {
  background-color: rgba(255, 255, 255, 0.25);
}

.linkedin-icon-container {
  background-color: rgba(255, 255, 255, 0.25);
}

.copy-icon-container {
  background-color: rgba(255, 255, 255, 0.25);
}

.arrow-icon {
  opacity: 0.7;
  transition: transform 0.3s ease;
}

.share-btn:hover .arrow-icon {
  transform: translateX(3px);
  opacity: 1;
}

.hover-effect {
  transition: opacity 0.2s;
}

.hover-effect:hover {
  opacity: 0.8;
}

.share-footer {
  background-color: #f5f5f5;
  border-top: 1px solid #eeeeee;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

/* Add this to your main CSS file for the bounce transition */
.dialog-bounce-transition-enter-active {
  animation: dialog-bounce-in 0.3s;
}

.dialog-bounce-transition-leave-active {
  animation: dialog-bounce-out 0.3s;
}

@keyframes dialog-bounce-in {
  0% {
    transform: scale(0.9);
    opacity: 0;
  }
  70% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}

@keyframes dialog-bounce-out {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.9);
    opacity: 0;
  }
}
</style>
